import React, { useEffect, useState, useContext } from "react";
import { Route, BrowserRouter, Switch, Redirect } from "react-router-dom";
import Api from "../utils/Api";
import MediaQuery from "react-responsive";
import { AppContext } from "../AppContext";
import { registerServiceWorker, setBadge } from "../utils/push";

import Login from "../login/Login";
import Menu from "../menu/Menu";
import TransactionsArchive from "../archive/ArchiveContainer";
import Approval from "../approval/ApprovalContainer";
import Balance from "../balance/BalanceContainer";
import AddTransaction from "../addTransaction/AddTransaction";
import Playground from "../playground/Playground";
import MonthCompare from "../monthCompare/MonthCompare";
import Management from "../management/ManagementContainer";
import Configuration from "../configuration/ConfigurationContainer";
import BudgetStatus from "../budgetStatus/BudgetStatusContainer";
import MonthSummary from "../monthSummary/MonthSummaryContainer";

import "./App.css";

const App = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const { setUser } = useContext(AppContext);

    useEffect(() => {
        async function renderData() {
            const authResponse = await Api.isAuthenticated();
            setIsAuthenticated(authResponse.isAuthenticated);

            if (authResponse.isAuthenticated && authResponse.userId) {
                setUser({
                    id: authResponse.userId,
                    email: authResponse.email,
                    name: authResponse.name,
                    customer: authResponse.customer
                });

                // Registering here (rather than only when subscribing) keeps the worker alive
                // so it can handle pushsubscriptionchange after the browser rotates a token.
                registerServiceWorker();

                const { response } = await Api.getPendingApprovalCount();
                setBadge(response?.count || 0);
            }
        }

        renderData();
    }, [setUser]);

    return (
        <BrowserRouter>
            <MediaQuery maxWidth="599px">
                {(isMobile) => {
                    {
                        return isAuthenticated ? (
                            <div>
                                {isMobile ? (
                                    <div />
                                ) : (
                                    <div
                                        style={{
                                            position: "fixed",
                                            left: 0,
                                            top: 0,
                                            width: "100%",
                                            zIndex: "900",
                                            backgroundColor: "#333"
                                        }}
                                    >
                                        <Menu />
                                    </div>
                                )}
                                <div
                                    style={{
                                        marginTop: isMobile ? "0px" : "65px",
                                        paddingBottom: isMobile ? "105px" : "0px",
                                    }}
                                >
                                    <Switch>
                                        <Route path="/content/approval" component={Approval} />
                                        <Route path="/content/addTransaction" component={AddTransaction} />
                                        <Route path="/content/archive" component={TransactionsArchive} />
                                        <Route path="/content/balance" component={Balance} />
                                        <Route path="/content/budgetStatus" component={BudgetStatus} />
                                        <Route path="/content/monthCompare" component={MonthCompare} />
                                        {/* <Route path="/content/logs" component={Automations} /> */}
                                        <Route path="/content/playground" component={Playground} />
                                        <Route path="/content/management" component={Management} />
                                        <Route path="/content/monthSummary" component={MonthSummary} />
                                        <Route path="/content/configuration" component={Configuration} />
                                        <Redirect to="/content/approval" />
                                    </Switch>
                                </div>
                                {isMobile ? (
                                    <div
                                        style={{
                                            position: "fixed",
                                            left: 0,
                                            bottom: 0,
                                            width: "100%",
                                            backgroundColor: "#333"
                                        }}
                                    >
                                        <Menu />
                                    </div>
                                ) : (
                                    <div />
                                )}
                            </div>
                        ) : (
                            <Switch>
                                <Route path="/login">
                                    <Login />
                                </Route>
                                <Redirect to="/login" />
                            </Switch>
                        );
                    }
                }}
            </MediaQuery>
        </BrowserRouter>
    );
};

export default App;
